module.exports = {
  url: '/weddings',
  template: require('raw!templates/weddings/weddings-view.html'),
  controller: WeddingsController,
  controllerAs: 'weddingsCtrl'
};

function WeddingsController($scope, $state, store, $window, contentful, $http, Socialshare, $timeout) {
  var vm = this;
  $window.scrollTo(0, 0);
  contentful.entries('content_type=longPage&sys.id=4GmahswIVaa64Ooau0qS2k').then(function (res) {
    console.log('weddings page contentful data', res);
    $scope.weddings = res.data.items[0];
    $scope.cateringImage = $scope.weddings.fields.sections[4].fields.image.fields.file.url;
    console.log('Catering Image', $scope.cateringImage);
    var seoData = res.data.items[0];
    if (seoData.fields.seoPageTitle) {
      document.title = seoData.fields.seoPageTitle;
    }
    if (seoData.fields.seoPageDescription) {
      var meta = document.getElementsByTagName("meta");
      for (var i = 0; i < meta.length; i++) {
        if (meta[i].name.toLowerCase() === "description") {
          meta[i].content = seoData.fields.seoPageDescription;
        }
      }
    }
  });
  vm.showForm = true;
  vm.showConfirmationLayer = false;
  vm.showErrorLayer = false;


  vm.submitForm = function (formValid) {
    if (!vm.contactForm.luncheon) {
      vm.contactForm.luncheon = ''
    } else {
      vm.contactForm.luncheon = 'Bridal Luncheon'
    }

    if (!vm.contactForm.dinner) {
      vm.contactForm.dinner = ''
    } else {
      vm.contactForm.dinner = 'Rehearsal Dinner'
    }

    if (!vm.contactForm.welcomeReception) {
      vm.contactForm.welcomeReception = ''
    } else {
      vm.contactForm.welcomeReception = 'Welcome Reception'
    }

    if (!vm.contactForm.ceremony) {
      vm.contactForm.ceremony = ''
    } else {
      vm.contactForm.ceremony = 'Ceremony'
    }

    if (!vm.contactForm.reception) {
      vm.contactForm.reception = ''
    } else {
      vm.contactForm.reception = 'Reception'
    }

    if (!vm.contactForm.brunch) {
      vm.contactForm.brunch = ''
    } else {
      vm.contactForm.brunch = 'Brunch'
    }

    if (!vm.contactForm.blocks) {
      vm.contactForm.blocks = ''
    } else {
      vm.contactForm.blocks = 'Room Blocks'
    }

    if (!vm.contactForm.pEmail) {
      vm.contactForm.pEmail = ''
    } else {
      vm.contactForm.pEmail = 'EMAIL'
    }

    if (!vm.contactForm.pPhone) {
      vm.contactForm.pPhone = ''
    } else {
      vm.contactForm.pPhone = 'PHONE'
    }



    if (formValid) {
      var postUrl = "/api/weddings";
      var reason = "test";
      var obj = {
        fromName: vm.contactForm.firstName + ' ' + vm.contactForm.lastName,
        fromEmail: vm.contactForm.email,
        toName: 'Wedding Coordinator',
        toEmail: 'parkcitypeaks.weddings@ldhg.com',
        subject: document.title,
        phone: vm.contactForm.phone,
        number: vm.contactForm.number,
        arrive: vm.contactForm.arrive,
        leave: vm.contactForm.leave,
        bride: vm.contactForm.bride,
        groom: vm.contactForm.groom,
        relationship: vm.contactForm.relationship,
        luncheon: vm.contactForm.luncheon,
        dinner: vm.contactForm.dinner,
        welcomeReception: vm.contactForm.welcomeReception,
        ceremony: vm.contactForm.ceremony,
        reception: vm.contactForm.reception,
        brunch: vm.contactForm.brunch,
        blocks: vm.contactForm.blocks,
        pEmail: vm.contactForm.pEmail,
        pPhone: vm.contactForm.pPhone,
        emailBody: vm.contactForm.comments
      };

      // FAKE FORM POST FOR DEVELOPMENT
      // console.log('valid, emailing ' + obj.toEmail)
      // vm.showConfirmationLayer = true;
      // $timeout(function(){
      //   vm.contactForm = '';
      //   vm.showConfirmationLayer = false;
      // }, 5000);

      $http.post(postUrl, obj).then(function success(res) {
        console.log('success: ', res);
        vm.showForm = false;
        vm.showConfirmationLayer = true;
        // $timeout(function() {
        // 	vm.contactForm = '';
        // 	vm.showConfirmationLayer = false;
        // }, 10000);
      }, function error(err) {
        console.log('error: ', err)
        window.glob = err;
        vm.showErrorLayer = true;
        $timeout(function () {
          vm.contactForm = '';
          vm.showErrorLayer = false;
        }, 5000);
      });
    } else {
      console.log("form invalid");
    }
  };
  setTimeout(function () {
    var elem = document.querySelector('.carousel');
    var flkty = new Flickity(elem, {
      imagesLoaded: true,
      draggable: false,
      percentPostion: false,
      cellAlign: 'center',
      wrapAround: true,
      lazyLoad: true,
      pageDots: false,
      autoPlay: true
    });
  }, 1000);
  vm.trustUrl = "trustUrl";

  trustUrl.$inject = ['$sce'];

  function trustUrl($sce) {
    return function (mediaUrl) {
      return $sce.trustAsResourceUrl(mediaUrl);
    };
  }

  $window.sr = ScrollReveal({
    reset: false
  });
  sr.reveal('.home-load', {
    duration: 1000
  });
  sr.reveal('#cafe', {
    distance: 0,
    duration: 1000,
    scale: 1.5
  }, 500);
  sr.reveal('#pool', {
    distance: 0,
    duration: 1000,
    scale: 1.5
  }, 500);
  sr.reveal('#fitness', {
    distance: 0,
    duration: 1000,
    scale: 1.5
  }, 500);

  // Open overlay when button is clicked
  $('.show-blue').on('click', function () {
    var contentID = $(this).data('target');
    $('#' + contentID).toggleClass('reveal');
    $(this).fadeOut(800, 'linear');
  });

  $('.show-white').on('click', function () {
    var contentID = $(this).data('target');
    $('#' + contentID).toggleClass('reveal');
    $(this).fadeOut(800, 'linear');
  });

  // Close overlay when the outside of menu is clicked
  $('.hide-blue').on('click', function () {
    $('.overlay.bg-blue').addClass('conceal').delay(300).queue(function () {
      $('.overlay.bg-blue').removeClass('conceal');
      $('.overlay.bg-blue').removeClass('reveal');
      $(this).dequeue();
      $(".show-blue").fadeIn(800, 'linear');
    });
  });
  $('.hide-white').on('click', function () {
    $('.overlay.bg-white').addClass('conceal').delay(300).queue(function () {
      $('.overlay.bg-white').removeClass('conceal');
      $('.overlay.bg-white').removeClass('reveal');
      $(this).dequeue();
      $(".show-white").fadeIn(800, 'linear');
    });
  });
  vm.socialShare = function (share) {
    if (share === 'facebook') {
      Socialshare.share({
        'provider': 'facebook',
        'attrs': {
          'socialshareUrl': 'https://www.parkcitypeaks.com/weddings',
          'socialshareQuote': 'Peaks Hotel | Weddings',
          'socialshareMedia': 'https://www.parkcitypeaks.com/images/_new assets/peaks-logo-social.png',
          'socialsharePopupHeight': '400',
          'socialsharePopupWidth': '400'
        }
      });
    } else if (share === 'twitter') {
      Socialshare.share({
        'provider': 'twitter',
        'attrs': {
          'socialshareUrl': 'https://www.parkcitypeaks.com/weddings',
          'socialshareText': 'Peaks Hotel | Weddings',
          'socialshareMedia': 'https://www.parkcitypeaks.com/images/_new assets/peaks-logo-social.png',
          'socialsharePopupHeight': '400',
          'socialsharePopupWidth': '400'
        }
      });
    } else if (share === 'pinterest') {
      Socialshare.share({
        'provider': 'pinterest',
        'attrs': {
          'socialshareUrl': 'https://www.parkcitypeaks.com/weddings',
          'socialshareText': 'Peaks Hotel | Weddings',
          'socialshareMedia': 'https://www.parkcitypeaks.com/images/_new assets/peaks-logo-social.png',
          'socialsharePopupHeight': '400',
          'socialsharePopupWidth': '400'
        }
      });
    } else if (share === 'email') {
      Socialshare.share({
        'provider': 'email',
        'attrs': {
          'socialshare-subject': 'Peaks Hotel | Weddings',
          'socialshare-body': 'Park City Peaks Hotel Weddings'
        }
      });
    }
  }
}


// WEBPACK FOOTER //
// ./components/templates/weddings/weddings-controller.js